.tuner {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 60;
  font-family: var(--font-dm-sans);
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: var(--brand-slate);
  color: var(--brand-paper);
  border: 1px solid var(--brand-steel);
  border-radius: var(--radius-pill);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s ease;
}

.toggle:hover {
  background: var(--brand-ember);
  border-color: var(--brand-ember);
}

.panel {
  position: absolute;
  right: 0;
  bottom: 48px;
  width: 280px;
  padding: 16px;
  background: rgba(20, 24, 28, 0.96);
  backdrop-filter: blur(12px) saturate(1.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: var(--radius-md);
  color: var(--brand-paper);
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 20px 60px -20px rgba(0, 0, 0, 0.6);
}

.title {
  font-family: var(--font-syne);
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--brand-ember);
  font-size: 0.875rem;
  text-transform: uppercase;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rowLabel {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
}

.rowLabel span:last-child {
  color: var(--brand-ember);
  font-weight: 600;
}

.slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  outline: none;
  cursor: pointer;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  background: var(--brand-ember);
  border-radius: 50%;
  border: none;
}

.slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: var(--brand-ember);
  border-radius: 50%;
  border: none;
}

.reset {
  margin-top: 4px;
  padding: 6px 10px;
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--radius-pill);
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
}

.reset:hover {
  color: var(--brand-paper);
  border-color: var(--brand-ember);
}
